import { isElementFocusable } from './is-element-focusable';

/**
 * Finds focusable elements inside a slot container
 */
export const getFocusableElements = (container: HTMLSlotElement): Array<HTMLElement> => {
  const FOCUSABLE_SELECTORS = 'a[href], button';
  const assignedElements = container?.assignedElements({ flatten: true });

  return assignedElements
    .filter((el): el is HTMLElement => el instanceof HTMLElement)
    .flatMap((el) => {
      const directMatch = el.matches(FOCUSABLE_SELECTORS) && isElementFocusable(el) ? [el] : [];

      const descendants = Array.from(el.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTORS)).filter(isElementFocusable);

      return [...directMatch, ...descendants];
    });
};
